import React from 'react';

const TaskIcon = props => (
	<svg className={props.class ? props.class : 'task-icon'} xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12">
		<path fill="none" fillRule="nonzero" stroke={props.stroke ? props.stroke : '#A1A1A1'} d="M5.388.5H.5v11h11V3.973L5.388.5z" />
	</svg>
);

export default TaskIcon;
